
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"29","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.495 1.902l9.78 4.71 2.423 10.617-6.78 8.503H9.072l-6.78-8.503L4.716 6.611zm11.43 3.442L14.495-.16 3.065 5.344.25 17.678l7.898 9.904h12.695l7.898-9.904z"}}),_c('path',{attrs:{"d":"M19.136 10.364a2.607 2.607 0 00-1.89-.864c-1.43-.023-2.589 1.148-2.589 2.615 0 .209.023.411.067.607-2.151-.136-4.059-1.222-5.335-2.858-.223.392-.351.85-.351 1.341 0 .93.457 1.755 1.152 2.242a2.536 2.536 0 01-1.173-.347v.034c0 1.298.892 2.387 2.076 2.64a2.51 2.51 0 01-1.169.039c.33 1.064 1.286 1.841 2.419 1.867a5.093 5.093 0 01-3.833 1.096 7.14 7.14 0 003.968 1.206c4.762.001 7.366-4.015 7.366-7.498 0-.114-.003-.228-.008-.341a5.231 5.231 0 001.292-1.346 5.067 5.067 0 01-1.487.394A2.584 2.584 0 0020.78 9.75c-.5.294-1.054.505-1.643.614"}})])
          )
        }
      }
    